import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Field, Control, Label } from "rbx";
import { useQuery } from "react-apollo";
import gql from "graphql-tag";

import Select from "react-select";

const ORDER_STATUS_QUERY = gql`
  query SystemCodes($where: SystemCodeWhereInput!) {
    SystemCodes(
      where: $where
      orderByMulti: [ListOrder_ASC, CodeDescription_ASC]
    ) {
      RecId
      Type
      Category
      CodeName
      CodeId
      CodeDescription
    }
  }
`;
const ORDER_STATUS_QUERY_REDUCED = gql`
  query SystemCodes($where: SystemCodeWhereInput!) {
    SystemCodes(
      where: $where
      orderByMulti: [ListOrder_ASC, CodeDescription_ASC]
    ) {
      RecId
      CodeDescription
    }
  }
`;
const OrderStatusSelect = ({
  value: initialValue,
  onChange = console.log,
  onBlur = console.log,
  showLabel = true,
  reduceFilter = false,
  CodeId_in = null
}) => {
  const [selected, setSelected] = useState([]);
  const [options, setOptions] = useState([]);
  const { data = { SystemCodes: [] }, loading } = useQuery(
    reduceFilter ? ORDER_STATUS_QUERY_REDUCED : ORDER_STATUS_QUERY,
    {
      variables: {
        where: reduceFilter
          ? {
              Category: "Order",
              CodeName: "OrderStatus",
              CodeId_in: CodeId_in || ["NB", "BP", "VD"]
            }
          : {
              Category: "Order",
              CodeName: "OrderStatus"
            }
      },
      fetchPolicy: "network-only"
    }
  );

  const handleChange = value => {
    setSelected(value);
    onChange({
      target: {
        name: "StatusRecIdRef_in",
        type: "select",
        value: Array.isArray(value) ? value.map(v => v.value) : null
      }
    });
  };

  useEffect(() => {
    if (Array.isArray(initialValue)) {
      const newValue = options.filter(opt =>
        initialValue.some(x => opt.value === x)
      );
      setSelected(newValue);
    }
  }, [initialValue, options]);

  useEffect(() => {
    setOptions(
      data.SystemCodes.map(({ RecId, CodeDescription }) => ({
        value: RecId,
        label: CodeDescription
      }))
    );
  }, [data.SystemCodes]);

  const handleBlur = () => {
    onBlur({
      target: {
        name: "StatusRecIdRef_in",
        type: "select",
        value: Array.isArray(selected) ? selected.map(v => v.value) : null
      }
    });
  };
  return (
    <Field>
      {showLabel && <Label>Order Status</Label>}
      <Control>
        <Select
          isMulti
          closeMenuOnSelect={false}
          isLoading={loading}
          name="StatusRecIdRef_in"
          options={options}
          value={selected}
          onBlur={handleBlur}
          onChange={handleChange}
        />
      </Control>
    </Field>
  );
};

OrderStatusSelect.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
  showLabel: PropTypes.bool,
  onBlur: PropTypes.func,
  reduceFilter: PropTypes.bool,
  CodeId_in: PropTypes.array
};
export default OrderStatusSelect;
